import React from 'react';
import { Button, ButtonColor, ButtonVariant, FormTemplate, IconType, TextInput } from 'ui-builder';
import { CreateGroupRequest, DetailsFieldGroup, useDetailsFieldGroupsAdminService } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';

export function CreateGroupForm(props: { afterSubmitFunc?: () => void }) {
  const detailsFieldGroupsService = useDetailsFieldGroupsAdminService();

  return (
    <FormTemplate<CreateGroupRequest, DetailsFieldGroup>
      title="Add New Details Field Group"
      submitFormFunc={async (data) => {
        const result = await detailsFieldGroupsService.createGroup(data);
        if (props.afterSubmitFunc) {
          props.afterSubmitFunc();
        }
        return result;
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
    >
      <TextInput source="name" label="Group Name" />
    </FormTemplate>
  );
}

export function CreateGroupButton() {
  const popupFormManager = usePopupFormManager();

  return (
    <Button
      text="Add Group"
      onClick={() => popupFormManager.openForm(<CreateGroupForm />)}
      color={ButtonColor.BLUE}
      variant={ButtonVariant.FILLED}
      iconType={IconType.PLUS}
    />
  );
}
